import React, { Fragment } from 'react';
import { showNotification } from './../../../utils';
import TextField from './TextField';
import SelectField from './SelectField';

const PenForm = React.memo((props) => {
    if (props.promotionalItem == null) {
        return null;
    }

    const continueHandler = () => {
        if (!props.ink || props.ink == null || props.ink === '') {
            return showNotification('Complete Information', 'Select an ink', 'info');
        }
        if (props.quantity === '') {
            return showNotification('Complete Information', 'Select a quantity', 'info');
        }

        if (props.cxmlData.buyer_cookie == null) {
            props.addToCart(1, props.history);
        } else {
            props.addToCart(2, props.history);
        }
    };

    const quantityOptions = [{ value: '', label: 'Select option' }];
    for (let i = 1; i <= 10; i++) {
        quantityOptions.push({
            value: i,
            label: i,
        });
    }

    let buttonLabel = 'Add To Cart';
    if (props.addingToCart) {
        buttonLabel = <Fragment><i className="fas fa-circle-notch fa-spin" /> Adding to Cart...</Fragment>;
    }

    const changeNotesHandler = (event) => {
        props.setNotes(event.target.value);
    };

    return (
        <div className="pen-form-container">
            <div className="preview-image-container">
                <img src="https://ac-ut-health.s3.amazonaws.com/promotional-images/pen-white1.jpg" alt="" />
                <img src="https://ac-ut-health.s3.amazonaws.com/promotional-images/pen-white2.jpg" alt="" />
                <img src="https://ac-ut-health.s3.amazonaws.com/promotional-images/pen-black.jpg" alt="" />
            </div>
            <div className="form-container">
                <div className="first-line">First Line: <img src={require('./../images/physicians-logo.png')} alt="UTP" className="utp-logo" /></div>
                <div className="second-line">
                    <div className="title">Second Line:</div>
                    <TextField
                        limit={25}
                        label="Clinic Name"
                        value={props.clinicName}
                        setFunction={props.setClinicName}
                        placeholder="Only 25 Characters"
                    />
                </div>
                <div className="second-line">
                    <div className="title">Third Line:</div>
                    <TextField
                        limit={25}
                        label="Phone #"
                        value={props.phone}
                        setFunction={props.setPhone}
                        placeholder="Only 25 Characters"
                    />
                </div>
                <SelectField
                    required
                    label="Ink Color"
                    value={props.ink}
                    setFunction={props.setInk}
                    options={[
                        { value: '', label: 'Select option' },
                        { value: 'White', label: 'White' },
                        { value: 'Black', label: 'Black' },
                    ]}
                />
                <SelectField
                    required
                    label="Quantity"
                    value={props.quantity}
                    setFunction={props.setQuantity}
                    options={[
                        { value: '', label: 'Select option' },
                        { value: '250', label: '250' },
                        { value: '500', label: '500' },
                        { value: '1000', label: '1000' },
                    ]}
                />
                <div className="variable notes-field">
                    <div className="label">Notes:</div>
                    <textarea value={props.notes} onChange={changeNotesHandler} />
                </div>
            </div>
            <div className="description-container">
                <h2>Javalina Metallic Stylus (331) Pen</h2>
                <h3>Silk Screen Imprint: 1 1/2" W x 3/4"</h3>
                <p>Recommended Imprint Color: White or Black</p>
                <p>Standard Production on catalog quantities is 5 days after proof approval, and AR approval. Added imprint options or special packaging may require additional production time.</p>
                <p>
                    <div><b>Material:</b> Plastic</div>
                    <div><b>Mechanism:</b> Push Retractable</div>
                    <div><b>Tip Type:</b> Ballpoint</div>
                    <div><b>Product Size:</b> 5 5/7" L x 1/3" Dia.</div>
                    <div><b>Shipping Information:</b> 5 lbs per 250</div>
                </p>
                <div className="text-right">
                    <button type="button" className="continue" onClick={continueHandler} disabled={props.addingToCart}>{buttonLabel}</button>
                </div>
            </div>
        </div>
    );
});

export default PenForm;
